export const HUD_MODULE_TOKEN = Symbol('HUD_MODULE_TOKEN');

export interface HudModule {
  initialize(): Promise<void>;
}
